'use client';

import { Button } from '@mui/material';

import { colors } from '@/styles/theme';

interface AppleAuthButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

const AppleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.08-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

export const AppleAuthButton = ({
  onClick,
  disabled = false,
  label = 'Continue with Apple',
}: AppleAuthButtonProps) => (
  <Button
    fullWidth
    variant="outlined"
    onClick={onClick}
    disabled={disabled}
    startIcon={<AppleIcon />}
    sx={(theme) => ({
      py: 1.25,
      borderRadius: 2.5,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
      mb: 1,
      ...(theme.palette.mode === 'dark'
        ? {
            bgcolor: colors.common.black,
            color: colors.common.white,
            borderColor: 'divider',
            '&:hover': {
              bgcolor: colors.common.blackHover,
              borderColor: colors.common.black,
            },
          }
        : {
            bgcolor: theme.palette.common.white,
            color: theme.palette.common.black,
            borderColor: theme.palette.grey[300],
            '&:hover': {
              bgcolor: theme.palette.grey[100],
              borderColor: theme.palette.grey[400],
            },
          }),
      '& .MuiButton-startIcon': {
        marginRight: 1,
      },
    })}
  >
    {label}
  </Button>
);
